import { render } from "./Index.vue?vue&type=template&id=f6ae809c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=f6ae809c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ae809c"],['__file',"components/Pages/Match/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6ae809c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6ae809c', __exports__)) {
    api.reload('f6ae809c', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=f6ae809c&scoped=true", () => {
    api.rerender('f6ae809c', render)
  })

}


export default __exports__